import React from "react";
import { Outlet } from "react-router-dom";

export const Probate = (): JSX.Element => {
  return <Outlet />;
};
